

export default {
  name: "HappyKidsInsurerTextAndImage",
  props: {
    data: {
      type: Object,
      default: () => { },
    }
  },
  data () {
    return {
      isActive: false,
    }
  },
  computed: {
    computedIsActive () {
      return this.isActive;
    },
    rightImageScr () {
      return this.data?.headImage?.url;
    },

  },
  mounted () {
  },
  methods: {
    toggleRemark () {
      this.isActive = !this.isActive;
    },
    iconSrc (icon) {
      return require(`@/assets/images/family/icon/${icon}.png`)
    }
  },
}
